import { useTranslation } from "react-i18next"
import Button from "customerAttachments/components/Button"
import { useNavigation } from "modules/navigation"

import PdfViewer from "components/PdfViewer"

import styles from "./styles.module.scss"

const PreviewPDF = ({ url }: { url: string }) => {
  const { navigateTo } = useNavigation()
  const { t } = useTranslation(["sales,label"])

  const backToUpload = () => {
    const urlObj = new URL(window.location.href)
    urlObj.searchParams.set("action", "edit")
    const targetUrl = urlObj.pathname + urlObj.search
    navigateTo(targetUrl)
  }

  return (
    <div className={styles.previewContainer}>
      <p>{t("sales:order.text_had_uploaded_file")}</p>
      <div className={styles.previewContainer_pdf}>
        <PdfViewer url={url} fullscreen={true} style={{ paddingBottom: "80px", position: "relative" }} />
      </div>
      <Button onClick={backToUpload} data-testid="reUpload-button">
        {t("label:re-upload")}
      </Button>
    </div>
  )
}

export default PreviewPDF
